export var MemberAllocationMutationTypes;
(function (MemberAllocationMutationTypes) {
    MemberAllocationMutationTypes["SET_MONTH_VALUE"] = "SET_MONTH_VALUE";
    MemberAllocationMutationTypes["SET_DAY_KEYS"] = "SET_DAY_KEYS";
    MemberAllocationMutationTypes["SET_LOADED_MEMBERS"] = "SET_LOADED_MEMBERS";
    MemberAllocationMutationTypes["SET_LOADED_MEMBER_START_INDEX"] = "SET_LOADED_MEMBER_START_INDEX";
    MemberAllocationMutationTypes["SET_TASKS_BY_MEMBER_AND_DAY"] = "SET_TASKS_BY_MEMBER_AND_DAY";
    MemberAllocationMutationTypes["SET_HAS_MORE_MEMBERS"] = "SET_HAS_MORE_MEMBERS";
    MemberAllocationMutationTypes["SET_HAS_MORE_MEMBERS_PREV"] = "SET_HAS_MORE_MEMBERS_PREV";
    MemberAllocationMutationTypes["SET_USER_OFFSET"] = "SET_USER_OFFSET";
    MemberAllocationMutationTypes["SET_IS_LOADING"] = "SET_IS_LOADING";
    MemberAllocationMutationTypes["SET_TOTAL_USERS"] = "SET_TOTAL_USERS";
    MemberAllocationMutationTypes["UPDATE_MEMBER_LIST"] = "UPDATE_MEMBER_LIST";
    MemberAllocationMutationTypes["SET_QUEUED_TIMELINE_OFFSET"] = "SET_QUEUED_TIMELINE_OFFSET";
    MemberAllocationMutationTypes["SET_STALE_LOADED_MONTHS"] = "SET_STALE_LOADED_MONTHS";
})(MemberAllocationMutationTypes || (MemberAllocationMutationTypes = {}));
